<template>
  <div>
    <table
      :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8"
      style="position: absolute"
      width="100%"
    >
      <tr height="48px" max-height="48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Imprime un listado de los producto vendido por vendedor.'"
          :titulo="'Ventas por Vendedor y Laboratorio'"
          @MethodAnular="anular"
          @MethodEliminar="remove"
          @MethodGuardar="save"
          @MethodImprimir="imprimirList"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </tr>

      <tr>
        <!-- BarraPrimaria --------------------------------------------------------------------------------->
        <td v-show="BarraTablaDinamicaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <v-btn-toggle>
                    <v-btn color="yellow accent-4" small @click.prevent="actualiza_tb_ver">
                      <i class="fa fa-eye" style="font-size: 25px"></i>
                      ver
                    </v-btn>
                    <v-btn
                      color="deep-purple accent-2"
                      dark
                      small
                      @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                    >
                      <i class="fa fa-print" style="font-size: 25px"></i>
                      Listado
                    </v-btn>
                  </v-btn-toggle>
                </center>
                <!-- <BarraBusqueda2
                  :url="
                    $hostname + $hName + '/services/tipocliente/findalltipoclientes'
                  "
                  :nombre="'Tipo de Clientes'"
                  :headers="headers"
                  :slotname="'item.descripcion'"
                  :emitnombre="'emitReportesProductoVendido'"
                  :SeachNombre="'Búsqueda por descripcion '"
                  :slotlist="slotlist"
                /> -->
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <img alt="Reporte" src="@/assets/iconos_micromarket/custom-reports.png" />
                  </v-avatar>

                  <span class="font-weight-light" style="font-size: 20px">
                    Listado de Ventas por Vendedor y Laboratorio
                  </span>

                  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                  <!-- style="color:white;" -->
                  <!-- <i class=""> </i> -->

                  <!-- <v-spacer></v-spacer> -->
                  <!-- <v-btn
                    color="grey darken-4"
                    fab
                    small
                    @click="cerrarmodalcuenta"
                  >
                   <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                  </v-btn> -->
                </v-toolbar>

                <hr />

                <v-container style="border: 1px solid #000000">
                  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  desde  -->
                        <v-text-field
                          v-model="ProductoVendido.desde"
                          dense
                          label="Fecha Incial:"
                          outlined
                          type="date"
                          @blur="BlurDesde"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-combobox
                          v-model="ProductoVendido.fabricante"
                          :items="RFabricante"
                          autocomplete="off"
                          dense
                          item-text="nombre"
                          label="Fabricante:"
                          outlined
                          @blur="SelctCbFabricante"
                          @focus="CargarFabricante"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-wrench" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <v-combobox
                          v-if="false"
                          v-model="ProductoVendido.sucursal"
                          :items="Rsucursal"
                          autocomplete="off"
                          dense
                          item-text="descripcion"
                          label="Sucursales:"
                          outlined
                          @blur="SelctCbSucursal"
                          @focus="cargarSucursal"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-sitemap" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>

                        <v-switch
                          v-model="ProductoVendido.resumido"
                          class="mt-0"
                          color="teal"
                          hide-details
                          inset
                          label="Formato Resumido:"
                        >
                          <template v-slot:label>
                            <strong v-if="ProductoVendido.resumido" style="color: #000000">Formato Resumido: Si</strong>
                            <strong v-if="ProductoVendido.resumido === false" style="color: #000000">
                              Formato Resumido: No
                            </strong>
                          </template>
                        </v-switch>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <!-- -----------------------------  hasta  -->
                        <v-text-field
                          v-model="ProductoVendido.hasta"
                          dense
                          label="Fecha Final:"
                          outlined
                          type="date"
                          @blur="BlurHasta"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-calendar" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-- ----------------------------- vendedores -->
                        <v-combobox
                          v-model="ProductoVendido.vendedores"
                          :items="RVendedores"
                          autocomplete="off"
                          dense
                          item-text="nombre"
                          label="Vendedores:"
                          outlined
                          @blur="SelctCbVendedores"
                          @focus="cargarVendedores"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-sign-language" style="font-size: 20px"></i>
                          </template>
                        </v-combobox>
                      
          <div style="border: 1px solid #000000;" v-if="this.ProductoVendido.resumido==true">
        <center>
        <span style="font-size: 12px"><b>RESUMEN POR:</b></span>

        <v-radio-group dense   hide-details class="pt-0 mt-0 d-flex justify-center "  v-model="ProductoVendido.ResumenPor" row>     
                          <v-radio  label="" color="green" :value="1">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">PRODUCTO</strong>
                            </template>
                          </v-radio>
                          <v-radio  label="" color="green" :value="2">
                            <template v-slot:label>
                              <strong style="color: #000000; font-size: 11px">VENDEDOR Y FABRICANTE</strong>
                            </template>
                          </v-radio>              
        </v-radio-group>
        </center>
 </div>
                      
                      </v-col>
                      <!-- fn columna 2 -->
                    </v-row>
                  </v-form>
                </v-container>

                <hr />

                <ModalReporteFiltros
                  ref="ModRepFilt"
                  :Datos="ProductoVendidoLink"
                  @DataReporteBasico="DDataReporteBasico"
                />
              </v-card>
            </v-container>
          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td v-show="BarraSecundariaAprir" :max-height="this.windowSize.height - 96" width="109">
          <div
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px', 'max-width': '325px', width: '325px' }"
          >
            <!--
                    <BarraBusqueda2
                          :url="$hostname + $hName + '/services/caja/findAll'"
                          :nombre="'Cajas'"
                          :headers="headers"
                          :slotname="'item.descripcion'"
                          :emitnombre="'emitCaja'"
                          :slotlist="slotlist"
                          :SeachNombre="'Búsqueda por descripción caja'"
                        /> -->
          </div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
    <!-- Modales -------------------------------------------------------------------------------------------------->
    <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      v-model="acti_tb_data"
      label="myAlert"
      max-height="100%"
      max-width="100%"
      persistent
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar color="#BDBDBD" flat>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>
          <v-toolbar-title class="font-weight-light">REPORTE</v-toolbar-title>
          <i class="fa fa-file-pdf-o" style="font-size: 20px"></i>

          <v-spacer></v-spacer>
          <v-btn color="grey darken-4" fab small @click="acti_tb_data = !acti_tb_data">
            <i class="fa fa-close" style="font-size: 20px; color: #dd4b39"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field v-model="search" hide-details label="Buscar" single-line @keyup="filtro">
                <template v-slot:prepend-inner>
                  <i class="fa fa-search" style="font-size: 35px"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table :headers="slotHtabla" :items="list" :search="search" dense @click:row="datostabla">
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog v-model="Elim_notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn small @click.prevent="eliminar(), (Elim_notif.estado = !Elim_notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="Elim_notif.estado = !Elim_notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import { EventBus } from "../../event-bus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros2"
  import {
    currencyFormatter,
    fechaNueva,
    FormatoFecha,
    getParamFecha,
    HoraFormatter,
    HoraFormatter2,
    RedondeoBasico,
    RedondeoValor,
    RedondeoValorCantRed,
  } from "@/js/Funciones.js"

  export default {
    components: {
      BarraBusqueda2,
      ContenidoBase,
      ModalReporteFiltros,
    },
    created() {},
    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      EventBus.$on("emitReportesProductoVendido", this.datostabla)
      EventBus.$on("onResize", this.onResize)

      this.$refs.ModRepFilt.CrearObjecto = this.validarObjecto
    },

    data: () => ({
      ListaTiposClientes: [],
      RFabricante: [],
      RVendedores: [],
      Rsucursal: [],
      windowSize: { width: "auto", height: "auto" },

      ProductoVendidoLink: {
        nombre: "LISTADO VENTAS POR VENDEDOR Y LABORATORIO",
        UrlImprimir: "/reportesInv/ventasvendedorlaboratorio",
        UrlExel: "/reportesInv/excel-ventasvendedorlaboratorio",
        UrlCorreo: "/reportesInv/correo-ventasvendedorlaboratorio",
      },

      ProductoVendido: {
        desde: fechaNueva(),
        hasta: fechaNueva(),
        fabricante: null,
        vendedores: null,
        sucursal: null,
        resumido: false,
        ResumenPor:1
      },

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      text: "",
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:",
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" },
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?",
      },

      aalert: {
        estado: false,
        color: null,
      },
    }),

    //   destroyed() {
    //     location.reload();
    //   },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      HoraFormatter2,
      RedondeoValor,
      RedondeoBasico,
      RedondeoValorCantRed,
      fechaNueva,
      getParamFecha,
      onResize(e) {
        this.windowSize = e
      },

      abrirTabla() {
        this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir
      },

      datostabla(e) {
        this.ProductoVendido = e
        this.acti_tb_data = false
      },
      save() {},
      remove() {},
      eliminar() {},
      anular() {},
      imprimirList() {},

      DDataReporteBasico() {},

      validarObjecto() {
        if (!this.$refs.form.validate()) {
          this.$refs.ModRepFilt.detener = true
          return
        } else {
          this.$refs.ModRepFilt.detener = false
        }

        var where = ` fecha>= ' ${this.ProductoVendido.desde} ' and fecha  <=' ${this.ProductoVendido.hasta} '`

        //this.VentasProductosClientes

        if (this.ProductoVendido.fabricante != null) {
          where += ` and p.fabricante= ${this.ProductoVendido.fabricante.codigo} `
          this.ProductoVendidoLink.fabricante = JSON.parse(JSON.stringify(this.ProductoVendido.fabricante.nombre))
        }

        if (this.ProductoVendido.vendedores != null) {
          where += ` and v.codigo= ${this.ProductoVendido.vendedores.codigo} `
          this.ProductoVendidoLink.vendedor = JSON.parse(JSON.stringify(this.ProductoVendido.vendedores.nombre))
        }

        if (this.ProductoVendido.sucursal != null) {
          where += ` and su.codigo= ${this.ProductoVendido.sucursal.codigo} `
          this.ProductoVendidoLink.sucursal = JSON.parse(JSON.stringify(this.ProductoVendido.sucursal.descripcion))
        }

        this.ProductoVendidoLink.where = where
        this.ProductoVendidoLink.desde = this.ProductoVendido.desde
        this.ProductoVendidoLink.hasta = this.ProductoVendido.hasta
        this.ProductoVendidoLink.resumido = this.ProductoVendido.resumido
        this.ProductoVendidoLink.ResumenPor=this.ProductoVendido.ResumenPor
      },
   //RESUMEN POR: 1-PRODUCTO , 2-VENDEDOR Y FABRICANTE
      newwnuevo() {
        ;(this.ProductoVendido = {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          descripcionOriginal: "",
          fechaCreacion: "",
          fechaModificacion: "",
          usuarioCreacion: "",
          usuarioModificacion: "",
        }),
          EventBus.$emit("actualizaBarraBusqueda2")
      },

      SelctCbFabricante() {
        if (this.ProductoVendido.fabricante == null) {
          this.ProductoVendido.fabricante = ""
        }

        if (this.ProductoVendido.fabricante.codigo == undefined) {
          // this.alerta("Seleccione un fabricante", "error");
          this.ProductoVendido.fabricante = ""
          return
        }
      },

      CargarFabricante() {
        this.$axios
          .get(this.$hostname + this.$hName + "/fabricante/activo", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => (this.RFabricante = res.data))
          .catch()
      },

      cargarVendedores() {
        this.$axios
          .get(this.$hostname + this.$hName + "/vendedores/findall", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => (this.RVendedores = res.data))
      },

      SelctCbVendedores() {
        if (this.ProductoVendido.vendedores == null) {
          this.ProductoVendido.vendedores = ""
        }

        if (this.ProductoVendido.vendedores.codigo == undefined) {
          this.alerta("Seleccione un vendedor", "error")
          this.ProductoVendido.vendedores = ""
          return
        }
      },

      cargarSucursal() {
        var headers = this.$store.getters.GetheadersAxios
        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: headers })
          .then((res) => {
            this.Rsucursal = res.data
          })
          .catch((error) => console.log(error))
      },

      SelctCbSucursal() {
        if (this.ProductoVendido.sucursal == null) {
          this.ProductoVendido.sucursal = ""
        }

        if (this.ProductoVendido.sucursal.codigo == undefined) {
          // this.alerta("Seleccione una Sucursal", "error");
          this.ProductoVendido.sucursal = ""
          return
        }
      },

      BlurDesde() {
        if (this.ProductoVendido.desde.toString().length == 0) {
          this.ProductoVendido.desde = this.fechaNueva()
        }
      },

      BlurHasta() {
        if (this.ProductoVendido.hasta.toString().length == 0) {
          this.ProductoVendido.hasta = this.fechaNueva()
        }
      },

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.newwnuevo()
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = false
        }
      },

      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.filtro()
      },

      async filtro() {},
    },
  }
</script>

<style></style>
